// extracted by mini-css-extract-plugin
export default {"container":"HW11_container__2Q6ok","wrapper":"HW11_wrapper__Ap3Ja","number":"HW11_number__NYWEz"};